import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API = `${process.env.VUE_APP_API_URL}crm/deals`;

export default {
  list(params = {}) {
    return axios.get(API, { params, headers: buildHeaders() });
  },
  get(id) {
    return axios.get(`${API}/${id}`, { headers: buildHeaders() });
  },
  create(data) {
    return axios.post(API, data, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(`${API}/${id}`, data, { headers: buildHeaders() });
  },
  remove(id) {
    return axios.delete(`${API}/${id}`, { headers: buildHeaders() });
  },
};
